import p1 from "../../assets/Mentors/Mentor/p1.png";
import p2 from "../../assets/Mentors/Mentor/p2.png";
import p3 from "../../assets/Mentors/Mentor/p3.png";
import p4 from "../../assets/Mentors/Mentor/p4.png";
import p5 from "../../assets/Mentors/Mentor/p5.png";
import p6 from "../../assets/Mentors/Mentor/p6.png";
import c1 from "../../assets/Mentors/Mentor/c1.png";
import c2 from "../../assets/Mentors/Mentor/c2.png";
import c3 from "../../assets/Mentors/Mentor/c3.png";
import c4 from "../../assets/Mentors/Mentor/c4.png";
import c5 from "../../assets/Mentors/Mentor/c5.png";
import c6 from "../../assets/Mentors/Mentor/c6.png";
import u1 from "../../assets/Mentors/Mentor/u1.png";
import u2 from "../../assets/Mentors/Mentor/u2.png";
import u3 from "../../assets/Mentors/Mentor/u3.png";
import u4 from "../../assets/Mentors/Mentor/u4.png";
import u5 from "../../assets/Mentors/Mentor/u5.png";
import u6 from "../../assets/Mentors/Mentor/u6.png";

export const mentors = [
  {
    name: "Dheeraj Dey",
    role: "Product Management",
    company: "AVL",
    companyLogo: c1,
    university: "RWTH Aachen University",
    universityLogo: u1,
    image: p1,
  },
  {
    name: "Safa'a Al-Adwan",
    role: "Human Resources consultant and business development Specialist",
    company: "Google",
    companyLogo: c2,
    university: "MIT",
    universityLogo: u2,
    image: p2,
  },
  {
    name: "Vijay Rana",
    role: "Lead Application Engineer",
    company: "Microsoft",
    companyLogo: c3,
    university: "Stanford University",
    universityLogo: u3,
    image: p3,
  },
  {
    name: "Saurabh Sarkar",
    role: "Business & Strategy Development",
    company: "OpenAI",
    companyLogo: c4,
    university: "Harvard",
    universityLogo: u4,
    image: p4,
  },
  {
    name: "Himanshu Chanana",
    role: "Business Analyst at Worldline",
    company: "Facebook",
    companyLogo: c5,
    university: "Berkeley",
    universityLogo: u5,
    image: p5,
  },
  {
    name: "Samy Thiyagarajan",
    role: "Co-Founder & COO Coracle",
    company: "Amazon",
    companyLogo: c6,
    university: "Oxford",
    universityLogo: u6,
    image: p6,
  },
];
